import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLoadingOneQuarter = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "none",
	viewBox: "0 0 22 22",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "#F2F2F2",
		d: "M22 11c0 6.075-4.925 11-11 11S0 17.075 0 11 4.925 0 11 0s11 4.925 11 11M2.751 11a8.249 8.249 0 1 0 16.498 0A8.249 8.249 0 0 0 2.75 11"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M11 0a11 11 0 0 1 10.462 7.6l-2.617.851A8.25 8.25 0 0 0 11 2.751z"
	})]
});
export default SvgLoadingOneQuarter;
